/* batida-inpost-fee.js: the T-shirt shipping fee ("Wysyłka koszulki InPost", 19,99 zł) kept in step with the cart on
   batida.pl (29.09, Pat / Aleksandra). Loaded on every batida.pl page by snippets/batida-locale-bridge.liquid, which also
   prints the config window.__batidaInpost = { vid, handle, price, priceText, freeFrom, note, cart: {merch, fee, basis} }.
   Rule: merch in the cart (a T-shirt: tag "merch" / type "Merch"; never the fee product itself, tag "inpost-fee") and the
   rest of the cart (every line but the fee, at original prices) under freeFrom (500 zł) -> the fee variant at quantity 1;
   500 zł and up -> quantity 0; no merch -> the fee line is removed.
   Runs: on load (from the printed facts; a request only when they disagree), after every change the theme announces
   (theme:cart:change) and after every cart request any script makes: window.fetch is observed - never altered - and the
   answers of /cart.js, /cart/change.js, /cart/update.js and /cart/clear.js carry the full cart, so the drawer's +/- and
   "Usuń" (which fire no event) are covered without extra requests. At most one write per change, one state at a time,
   and a state whose write failed is not retried (no loops). After a write the theme is told the usual way
   (theme:cart:change with the fresh cart, plus theme:cart:reload on /cart so the lines and totals redraw).
   The drawer's fee line (assets/batida-drawer.js untouched): no stepper, no remove button, no preorder text (CSS by
   variant id), a note "dodawana automatycznie" and a parcel icon instead of the empty photo (MutationObserver).
   Helpers for the cart-page box (assets/batida-v7-cart-inpost.js): window.__batidaInpostFee. */
(function () {
  'use strict';
  if (window.__batidaInpostFeeLoaded) return;
  window.__batidaInpostFeeLoaded = true;
  var C = window.__batidaInpost;
  if (!C || !C.vid) return;
  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  var VID = parseInt(C.vid, 10), FREE = parseInt(C.freeFrom, 10) || 50000, SRC = 'batida-inpost-fee';
  var nativeFetch = window.fetch;
  function noop() {}
  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  function isFee(i) { return !!i && (i.variant_id === VID || (!!C.handle && i.handle === C.handle)); }
  // /cart.js has no tags and translates product_type on /en ("Merch" -> "Merchandise"): type prefix + the ids the
  // locale bridge / merch page printed (window.__batidaMerchIds, without the fee).
  function isMerch(i) { return !!i && !isFee(i) && (/^merch/i.test(String(i.product_type || '')) || (window.__batidaMerchIds || []).indexOf(i.product_id) >= 0); }
  function items(cart) { return (cart && cart.items && cart.items.length != null) ? cart.items : []; }
  function basis(cart) { var b = 0; items(cart).forEach(function (i) { if (!isFee(i)) b += (i.original_line_price != null ? i.original_line_price : i.line_price) || 0; }); return b; }
  function hasMerch(cart) { return items(cart).some(isMerch); }
  function hasCake(cart) { return items(cart).some(function (i) { return !isFee(i) && !isMerch(i); }); }
  function feeLine(cart) { return items(cart).filter(isFee)[0] || null; }
  function isFree(cart) { return basis(cart) >= FREE; }
  function wanted(cart) { return hasMerch(cart) && !isFree(cart) ? 1 : 0; }
  window.__batidaInpostFee = { isFee: isFee, isMerch: isMerch, basis: basis, hasMerch: hasMerch, hasCake: hasCake, isFree: isFree, wanted: wanted, free: FREE, vid: VID, ensure: ensure };

  // Before the checkout (assets/batida-connect.js, audit 30.09 A-05): the fee line must be right. A fresh cart; if it
  // disagrees, one more write (also for a state whose write failed before). Rejects while the cart still disagrees, so the
  // checkout stays closed with a message instead of sending a T-shirt without its fee.
  function has(c) { var l = feeLine(c); return l ? l.quantity : 0; }
  function ensure() {
    return getCart().then(function (c) {
      if (wanted(c) === has(c)) return c;
      failedSig = ''; writes = [];
      return sync(c).then(getCart).then(function (f) { if (wanted(f) !== has(f)) throw new Error('inpost-fee'); return f; });
    });
  }

  function post(path, body) {
    return nativeFetch.call(window, ROOT + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
  }
  function getCart() {
    return nativeFetch.call(window, ROOT + '/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
  }
  function announce(cart) {
    try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart, source: SRC }, bubbles: true })); } catch (e) {}
    if (document.querySelector('[data-section-type="cart"]')) {
      try { document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true })); } catch (e) {}
    }
  }

  // ---- keep the fee line in step ----
  var busy = false, again = false, failedSig = '', writes = [];
  function sig(cart) { var l = feeLine(cart); return hasMerch(cart) + '|' + basis(cart) + '|' + (l ? l.quantity : 0); }
  function sync(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var want = wanted(cart), line = feeLine(cart), have = line ? line.quantity : 0;
    if (want === have) return Promise.resolve(cart);
    if (busy) { again = true; return Promise.resolve(cart); }
    var s = sig(cart);
    if (s === failedSig) return Promise.resolve(cart);                      // this exact state failed once: leave it
    var now = Date.now(); writes = writes.filter(function (t) { return now - t < 10000; });
    if (writes.length >= 4) return Promise.resolve(cart);                    // safety cap: 4 writes per 10 s
    writes.push(now);
    busy = true;
    var write = (want === 1 && !line) ? post('/cart/add.js', { items: [{ id: VID, quantity: 1 }] })
      : post('/cart/change.js', { id: line.key, quantity: want });
    return write.then(getCart)
      .then(function (fresh) { failedSig = ''; announce(fresh); return fresh; })
      .catch(function () { failedSig = s; return cart; })
      .then(function (c) { busy = false; if (again) { again = false; return getCart().then(sync).catch(function () { return c; }); } return c; });
  }

  // ---- triggers ----
  document.addEventListener('theme:cart:change', function (e) {
    var d = e && e.detail;
    if (d && d.cart && d.cart.items) sync(d.cart);
    else getCart().then(sync).catch(noop);
  });
  // Every full cart any script receives (drawer, theme, Batida Connect, the gift card...) passes through here as well.
  try {
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart(?:\.js|\/change\.js|\/update\.js|\/clear\.js)(?:[?#]|$)/.test(url)) {
          p.then(function (r) {
            if (!r || !r.ok) return;
            try { r.clone().json().then(function (c) { if (c && c.items) sync(c); }).catch(noop); } catch (x) {}
          }, noop);
        }
      } catch (x) {}
      return p;
    };
  } catch (e) {}
  // On load: the facts printed with the page; a request only when they disagree with the rule. On /cart the page may
  // have been rendered a moment before a fee write finished (a T-shirt added, the cart link clicked at once): then
  // the live cart differs from the printed facts and the lines are redrawn even though nothing needs writing. Waits
  // for DOMContentLoaded so the theme's cart section (which listens for the redraw) exists by the time the answer comes.
  function onLoad() {
    var f = C.cart || {}, merch = f.merch > 0, fee = f.fee || 0, want = merch && (f.basis || 0) < FREE ? 1 : 0;
    var cartPage = !!document.querySelector('[data-section-type="cart"]');
    if (want === fee && !cartPage) return;
    if (want === fee && !(merch || fee)) return;
    getCart().then(function (c) {
      var l = feeLine(c), have = l ? l.quantity : 0;
      if (cartPage && have !== fee && wanted(c) === have) announce(c);   // in step already, but the page shows the old cart
      return sync(c);
    }).catch(noop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad); else onLoad();

  // ---- the drawer's fee line ----
  var NOTE = C.note || 'dodawana automatycznie';
  var ICON = '<svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9M7.75 5.25l8.5 4.5"/></svg>';
  var st = document.createElement('style');
  st.textContent = '.batida-cart-drawer__line[data-line-key^="' + VID + ':"] .batida-cart-drawer__line__qty,' +
    '.batida-cart-drawer__line[data-line-key^="' + VID + ':"] .batida-cart-drawer__line__remove,' +
    '.batida-cart-drawer__line[data-line-key^="' + VID + ':"] .batida-cart-drawer__line__pre{display:none !important}' +
    '.batida-cart-drawer__line .bk-icon{display:flex;width:100%;height:100%;align-items:center;justify-content:center;color:#8a7868}' +
    '.batida-cart-drawer__line .bk-auto{font-style:italic}';
  (document.head || document.documentElement).appendChild(st);
  function decorate(root) {
    $$('.batida-cart-drawer__line[data-line-key^="' + VID + ':"]', root).forEach(function (line) {
      $$('a[href]', line).forEach(function (a) { a.removeAttribute('href'); });        // the fee product has no page to visit
      if (!line.querySelector('[data-bk-note]')) {
        var t = line.querySelector('.batida-cart-drawer__line__title'), p = document.createElement('p');
        p.className = 'batida-cart-drawer__line__variant bk-auto'; p.setAttribute('data-bk-note', ''); p.textContent = NOTE;
        if (t && t.parentNode) t.parentNode.insertBefore(p, t.nextSibling);
      }
      var img = line.querySelector('.batida-cart-drawer__line__img');
      if (img && !img.querySelector('img') && !img.querySelector('[data-bk-icon]')) {
        var s = document.createElement('span'); s.className = 'bk-icon'; s.setAttribute('data-bk-icon', ''); s.innerHTML = ICON; img.appendChild(s);
      }
    });
  }
  function watchDrawer() {
    var d = document.getElementById('batida-cart-drawer');
    if (!d || d.__bkWatched) return !!d;
    d.__bkWatched = true;
    decorate(d);
    try {
      new MutationObserver(function (muts) {
        var ours = muts.every(function (m) { return [].every.call(m.addedNodes, function (n) { return n.nodeType !== 1 || n.hasAttribute('data-bk-note') || n.hasAttribute('data-bk-icon'); }) && !m.removedNodes.length; });
        if (!ours) decorate(d);
      }).observe(d, { childList: true, subtree: true });
    } catch (e) {}
    return true;
  }
  (function poll(n) { if (watchDrawer() || n <= 0) return; setTimeout(function () { poll(n - 1); }, 500); })(20);
  document.addEventListener('theme:cart:change', function () { setTimeout(watchDrawer, 150); });
})();
